import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const sidebarItems = [
  { path: '/pipeline',       icon: 'hub',            label: 'Dashboard' },
  { path: '/discover',       icon: 'travel_explore', label: 'Discover News' },
  { path: '/content',        icon: 'dataset',        label: 'Articles' },
  { path: '/feedback',       icon: 'rate_review',    label: 'Feedback Desk' },
  { path: '/sources',        icon: 'rss_feed',       label: 'Sources' },
  { path: '/url-to-article', icon: 'link',           label: 'URL to Article' },
  { path: '/logs',           icon: 'history',        label: 'Logs' },
  { path: '/help',           icon: 'help',           label: 'Help' },
];

export const SIDEBAR_EXPANDED_W  = 220;
export const SIDEBAR_COLLAPSED_W = 56;

const Sidebar: React.FC<{ onWidthChange?: (w: number) => void }> = ({ onWidthChange }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    const next = !collapsed;
    setCollapsed(next);
    onWidthChange?.(next ? SIDEBAR_COLLAPSED_W : SIDEBAR_EXPANDED_W);
  };

  const w = collapsed ? SIDEBAR_COLLAPSED_W : SIDEBAR_EXPANDED_W;

  return (
    <aside
      className="fixed left-0 top-16 bottom-0 z-40 hidden md:flex flex-col transition-all duration-200"
      style={{
        width: w,
        background: '#ffffff',
        borderRight: '1px solid #e2e8f0',
        overflow: 'hidden',
      }}
    >
      <div className="flex flex-col gap-0.5 px-2 pt-3 flex-1 min-h-0 overflow-y-auto overflow-x-hidden">

        {/* Collapse toggle */}
        <button
          onClick={toggle}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          className="flex items-center justify-center w-8 h-8 rounded-lg self-end mb-2 transition-all"
          style={{ color: '#94a3b8', flexShrink: 0 }}
          onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = '#f1f5f9'; (e.currentTarget as HTMLElement).style.color = '#4f46e5'; }}
          onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = 'transparent'; (e.currentTarget as HTMLElement).style.color = '#94a3b8'; }}
        >
          <span className="material-symbols-outlined text-[18px]">
            {collapsed ? 'chevron_right' : 'chevron_left'}
          </span>
        </button>

        <nav className="flex flex-col gap-0.5">
          {sidebarItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              title={collapsed ? item.label : undefined}
              className="flex items-center rounded-lg transition-all overflow-hidden"
              style={({ isActive }) => ({
                gap: collapsed ? 0 : 10,
                padding: collapsed ? '9px 0' : '9px 10px',
                justifyContent: collapsed ? 'center' : 'flex-start',
                color: isActive ? '#4f46e5' : '#475569',
                background: isActive ? 'rgba(79,70,229,0.08)' : 'transparent',
                borderLeft: isActive ? '3px solid #4f46e5' : '3px solid transparent',
                paddingLeft: collapsed ? 0 : isActive ? 'calc(10px - 3px)' : '10px',
                fontWeight: isActive ? 600 : 400,
                minWidth: 0,
              })}
            >
              {({ isActive }) => (
                <>
                  <span
                    className="material-symbols-outlined text-[20px] flex-shrink-0"
                    style={{ color: isActive ? '#4f46e5' : '#94a3b8' }}
                  >
                    {item.icon}
                  </span>
                  {!collapsed && (
                    <span
                      className="text-[13px] whitespace-nowrap"
                      style={{ fontFamily: '"Space Grotesk", system-ui, sans-serif' }}
                    >
                      {item.label}
                    </span>
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Footer */}
      {!collapsed && (
        <div className="px-3 pb-3">
          <div className="px-2 py-1.5 rounded text-center" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
            <p className="font-mono text-[10px]" style={{ color: '#94a3b8' }}>
              AlCircle v2.4
            </p>
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
